// useSearch — TanStack Query wrapper for the global search endpoint.
// Only enabled when query has at least 2 characters.
//
// F24 (Task 131): Full implementation.

import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { searchEntities } from '../../api/endpoints/search';
import { queryKeys } from '../../api/queryKeys';
import type { SearchResponse } from '../../api/generated/schema';

export function useSearch(query: string): UseQueryResult<SearchResponse> {
  return useQuery({
    queryKey: queryKeys.search(query),
    queryFn: () => searchEntities(query),
    enabled: query.length >= 2,
    staleTime: 30_000,
  });
}
